import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const HighlightWrapper = styled.div`
  margin: 1rem 0;
`;

export const HighlightedOfferPanel = styled.div`
  display: grid;
  justify-items: stretch;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;

  ${media.mediumUp`
    grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
  `};
`;
